import React from "react";

export default function PillAutorizado() {
  return <div className="pill autorizado">Autorizado</div>;
}
